<template>
  <div id="app">
    <PGPHeader />
    <main class="app-content">
      <router-view />
    </main>
    <PGPFooter />
  </div>
</template>

<style>
html,
body {
  width: 100%;
  overflow-x: hidden;
}
#app {
  -webkit-tap-highlight-color: transparent;
  width: 100%;
  overflow-x: hidden;
  background-color: #fafafa;
}
.app-content {
  padding-top: 48px;
}
</style>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import PGPHeader from "./components/Header";
import PGPFooter from "./components/Footer";
import { eventBus } from "./eventBus";

const router = useRouter();

const handleScroll = () => {
  if (router.currentRoute.value?.name === "Home") {
    eventBus.$emit(
      "changeHeaderTransparency",
      window.scrollY || window.pageYOffset || 0,
    );
  }
};

const handlePageRequest = () => {
  eventBus.$emit("pageResponse", router.currentRoute.value);
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  eventBus.$on("pageRequest", handlePageRequest);
  eventBus.$emit("pageResponse", router.currentRoute.value);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  eventBus.$off("pageRequest", handlePageRequest);
});
</script>
